document.addEventListener("DOMContentLoaded", function () {

  const openBtn = document.getElementById("see-size-video");
  const modal = document.getElementById("roami-video-modal");
  const form = document.getElementById("roami-fit-form");
  const closeBtn = document.getElementById("roami-close");
  const cancelBtn = document.getElementById("roami-cancel");
  const resultContainer = document.getElementById("roami-video-result");

  if (!openBtn) return;

  openBtn.addEventListener("click", () => {
    modal.showModal();
  });

  closeBtn.addEventListener("click", () => {
    modal.close();
    // resultContainer.innerHTML = "";
    document.getElementById("roami-video-container").innerHTML = "";
  document.getElementById("roami-measurement-result").innerHTML = "";
  });

  cancelBtn.addEventListener("click", () => {
    modal.close();
    // resultContainer.innerHTML = "";
    document.getElementById("roami-video-container").innerHTML = "";
  document.getElementById("roami-measurement-result").innerHTML = "";
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const formData = new FormData(form);

    const user = {
    //   product: ShopifyAnalytics.meta.product.handle,
    profile: MEASUREMENT_PROFILE,
      gender: formData.get("gender"),
      size_system: formData.get("size_system"), // US or UK
      numeric_size: Number(formData.get("numeric_size")),
      height: Number(formData.get("height")),
      chest: Number(formData.get("chest"))
    };

    const measurementContainer = document.getElementById("roami-measurement-result");
    const videoContainer = document.getElementById("roami-video-container");

    const HEIGHT_MAX = 190;
    const HEIGHT_MIN = 150;
    const US_SIZE_MAX = 34;
    const US_SIZE_MIN = 2;
    const UK_SIZE_MAX = 40;
    const UK_SIZE_MIN = 5;

    const UK_CIRRUS_LINK = 'https://deltaroam.com/pages/size-guide-cirrus-jacket';
    const US_CIRRUS_LINK = 'https://deltaroam.com/en-us/pages/size-guide-cirrus-jacket-us';
    const UK_BEAUMONT_LINK = 'https://deltaroam.com/pages/size-guide-robes';
    const US_BEAUMONT_LINK = 'https://deltaroam.com/en-us/pages/size-guide-robes-us';

    const sizeChartIndex = JSON.parse(
      document.getElementById("roami-size-chart-recommendation-index").textContent
    );

    
    const recommendedSize = findRecommendedSize(sizeChartIndex, user);

  // -----------------------------
  // INPUT VALIDATION
  // -----------------------------
  let invalid = false;
  let message = `
  Your exact height and size combination is not yet featured in our model videos.

  The guide is a reference.
  The robe is designed with flexible layering space, so most customers fall comfortably within the recommended size.

  If you would like tailored guidance, our team will gladly advise.
    `;
  let size_link = ''

  if (user.size_system === "UK" && user.profile === 'beaumont'){
      size_link = UK_BEAUMONT_LINK;
    }
    if (user.size_system === "US" && user.profile === 'beaumont'){
      size_link = US_BEAUMONT_LINK;
    }
    if (user.size_system === "UK" && user.profile === 'cirrus'){
      size_link = UK_CIRRUS_LINK;
    }
    if (user.size_system === "US" && user.profile === 'cirrus'){
      size_link = US_CIRRUS_LINK;
    }

  // Height check
  if (user.height < HEIGHT_MIN || user.height > HEIGHT_MAX) {
    invalid = true;
  }

  // Size check
  if (!invalid) {
    if (user.size_system === "UK" && (user.numeric_size < UK_SIZE_MIN || user.numeric_size > UK_SIZE_MAX)) {
      invalid = true;
    }
    if (user.size_system === "US" && (user.numeric_size < US_SIZE_MIN || user.numeric_size > US_SIZE_MAX)) {
      invalid = true;
    }
  }

  if (invalid) {

    videoContainer.innerHTML = "";
    measurementContainer.innerHTML = `
    <h4 style="margin: 0 0 12px; font-size: 14px; color: #111; ">
      recommended size: <span style="color: #e00; font-weight: 700;">${recommendedSize}</span>
    </h4>
    <p style="margin: 10px 0 10px 0; font-size: 12px; color: rgba(0,0,0,0.55); ">
    See more details on our
    <a href="${size_link}" target="_blank" style="color:#000; text-decoration: underline;">
      Size Guide
    </a>.</p>`;
    return;
  }

    const index = JSON.parse(
      document.getElementById("roami-video-index").textContent
    );

  //   const videoContainer = document.getElementById("roami-video-container");
  // const measurementContainer = document.getElementById("roami-measurement-result");

// ----------------------------
// VIDEO ONLY
// ----------------------------
// videoContainer.innerHTML = `
//   <div style="margin-top: 14px; width: 100%; display: flex; justify-content: center;">
//     <div style="width: 100%; max-width: 320px; border-radius: 14px; overflow: hidden; background: #000; box-shadow: 0 4px 20px rgba(0,0,0,0.12);">
//       <video
//         controls
//         autoplay
//         playsinline
//         style="width: 100%; height: auto; display: block; object-fit: cover; max-height: 70vh; border-radius: 14px;"
//       >
//         <source src="${video.url}" type="video/mp4">
//       </video>
//     </div>
//   </div>
// `;

// ----------------------------
// MEASUREMENTS + RECOMMENDATION
// ----------------------------
measurementContainer.innerHTML = `
  <div style="margin-top: 16px; padding: 16px; border: 1px solid rgba(0,0,0,0.10); border-radius: 14px; background: rgba(0,0,0,0.02);">
    <h4 style="margin: 0 0 12px; font-size: 14px; color: #111; ">
      recommended size: <span style="color: #e00; font-weight: 700;">${recommendedSize}</span>
    </h4>
  </div>
  
  <p style="margin: 10px 0 10px 0; font-size: 12px; color: rgba(0,0,0,0.55); ">
    See more details on our
    <a href="${size_link}" target="_blank" style="color:#000; text-decoration: underline;">
      Size Guide
    </a> page.</p>
`;

    // const best = findBestVideo(index, user);

    // if (best) {
    //   renderVideo(best, size_link, recommendedSize);
    // } else {
    //     const measurementContainer = document.getElementById("roami-measurement-result");
    //   measurementContainer.innerHTML = "<p>No suitable video found.</p>";
    // }
  });

});

function findBestVideo(videos, user) {

  // ----------------------------------
  // 1. Filter by Product + Gender
  // ----------------------------------

  let candidates = videos.filter(v =>
    // v.product === user.product &&
    v.profile === user.profile &&
    v.gender === user.gender
  );

  if (!candidates.length) return null;

  const sizeKey = user.size_system === "US" ? "us_size" : "uk_size";

  // =====================================================
  // FEMALE LOGIC
  // =====================================================

  if (user.gender === "F") {

    // ----------------------------------
    // STEP 1 — Match Closest Size First
    // ----------------------------------

    let minSizeDiff = Infinity;
    let sizeMatched = [];

    candidates.forEach(v => {

      const diff = Math.abs(v[sizeKey] - user.numeric_size);

      if (diff < minSizeDiff) {
        minSizeDiff = diff;
        sizeMatched = [v];
      } else if (diff === minSizeDiff) {
        sizeMatched.push(v);
      }

    });

    if (!sizeMatched.length) return null;

    candidates = sizeMatched;

    // ----------------------------------
    // STEP 2 — Among Size Matches, Pick Closest Height
    // ----------------------------------

    let minHeightDiff = Infinity;
    let heightMatched = [];

    candidates.forEach(v => {

      const diff = Math.abs(v.height - user.height);

      if (diff < minHeightDiff) {
        minHeightDiff = diff;
        heightMatched = [v];
      } else if (diff === minHeightDiff) {
        heightMatched.push(v);
      }

    });

    candidates = heightMatched;

    // ----------------------------------
    // STEP 3 — Tie Break Using Chest
    // ----------------------------------

    let best = candidates[0];
    let minChestDiff = Math.abs(best.chest - user.chest);

    candidates.forEach(v => {

      const diff = Math.abs(v.chest - user.chest);

      if (diff < minChestDiff) {
        minChestDiff = diff;
        best = v;
      }

    });

    return best;
  }

  // =====================================================
  // MALE LOGIC
  // =====================================================

  if (user.gender === "M") {

    // Step 1 — Height Match
    let minHeightDiff = Infinity;
    let heightMatched = [];

    candidates.forEach(v => {

      const diff = Math.abs(v.height - user.height);

      if (diff < minHeightDiff) {
        minHeightDiff = diff;
        heightMatched = [v];
      } else if (diff === minHeightDiff) {
        heightMatched.push(v);
      }

    });

    candidates = heightMatched;

    // Step 2 — Chest Match
    let minChestDiff = Infinity;
    let chestMatched = [];

    candidates.forEach(v => {

      const diff = Math.abs(v.chest - user.chest);

      if (diff < minChestDiff) {
        minChestDiff = diff;
        chestMatched = [v];
      } else if (diff === minChestDiff) {
        chestMatched.push(v);
      }

    });

    candidates = chestMatched;

    // Step 3 — Tie Break Using Size (UK/US)
    let best = candidates[0];
    let minSizeDiff = Math.abs(best[sizeKey] - user.numeric_size);

    candidates.forEach(v => {

      const diff = Math.abs(v[sizeKey] - user.numeric_size);

      if (diff < minSizeDiff) {
        minSizeDiff = diff;
        best = v;
      }

    });

    return best;
  }

  return null;
}


/* ============================================================
   RENDER RESULT
============================================================ */

function renderVideo(video, size_link, recommendedSize) {

  let message = `
If you would like tailored guidance, our team will gladly advise.
  `;

  const videoContainer = document.getElementById("roami-video-container");
  const measurementContainer = document.getElementById("roami-measurement-result");

// ----------------------------
// VIDEO ONLY
// ----------------------------
videoContainer.innerHTML = `
  <div style="margin-top: 14px; width: 100%; display: flex; justify-content: center;">
    <div style="width: 100%; max-width: 320px; border-radius: 14px; overflow: hidden; background: #000; box-shadow: 0 4px 20px rgba(0,0,0,0.12);">
      <video
        controls
        autoplay
        playsinline
        style="width: 100%; height: auto; display: block; object-fit: cover; max-height: 70vh; border-radius: 14px;"
      >
        <source src="${video.url}" type="video/mp4">
      </video>
    </div>
  </div>
`;

// ----------------------------
// MEASUREMENTS + RECOMMENDATION
// ----------------------------
measurementContainer.innerHTML = `
  <div style="margin-top: 16px; padding: 16px; border: 1px solid rgba(0,0,0,0.10); border-radius: 14px; background: rgba(0,0,0,0.02);">
    <h4 style="margin: 0 0 12px; font-size: 14px; color: #111; ">
      recommended size: <span style="color: #e00; font-weight: 700;">${recommendedSize}</span>
    </h4>

    <p style="margin: 0 0 10px; font-size: 12px; color: rgba(0,0,0,0.55); text-transform: lowercase;">Model wearing <span style="font-weight: bold; color: #111; text-transform: uppercase;">${video.size_worn}</span> with measurements (closest to your build)</p>

    <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
      <tbody>
        <tr>
          <td style="padding: 8px 10px; border: 1px solid rgba(0,0,0,0.08); border-radius: 8px; background: #fff; width: 50%;">
            <span style="display: block; font-size: 11px; color: rgba(0,0,0,0.45); text-transform: lowercase; margin-bottom: 2px;">height</span>
            <strong>${video.height} cm</strong>
          </td>
          <td style="padding: 8px 10px; border: 1px solid rgba(0,0,0,0.08); border-radius: 8px; background: #fff; width: 50%;">
            <span style="display: block; font-size: 11px; color: rgba(0,0,0,0.45); text-transform: lowercase; margin-bottom: 2px;">chest</span>
            <strong>${video.chest} cm</strong>
          </td>
        </tr>
        <tr>
          <td style="padding: 8px 10px; border: 1px solid rgba(0,0,0,0.08); border-radius: 8px; background: #fff;">
            <span style="display: block; font-size: 11px; color: rgba(0,0,0,0.45); text-transform: lowercase; margin-bottom: 2px;">uk size</span>
            <strong>${video.uk_size}</strong>
          </td>
          <td style="padding: 8px 10px; border: 1px solid rgba(0,0,0,0.08); border-radius: 8px; background: #fff;">
            <span style="display: block; font-size: 11px; color: rgba(0,0,0,0.45); text-transform: lowercase; margin-bottom: 2px;">us size</span>
            <strong>${video.us_size}</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <p style="margin: 10px 0 10px 0; font-size: 12px; color: rgba(0,0,0,0.55); ">
    See more details on our
    <a href="${size_link}" target="_blank" style="color:#000; text-decoration: underline;">
      Size Guide
    </a> page.</p>
`;
}

function findRecommendedSize(sizeCharts, user){

  const chart = sizeCharts.find(c => c.profile === user.profile);
  if (!chart) return 'N/A';

  const rows = chart.size_chart;

  if (user.height < 140 || user.height > 220) return 'N/A';

  // ----------------------------------
  // Find closest height row
  // ----------------------------------

  let closestHeightRow = null;
  let minHeightDiff = Infinity;

  rows.forEach(r => {

    const height = Number(r.height_cm);
    const diff = Math.abs(height - user.height);

    if (diff < minHeightDiff) {
      minHeightDiff = diff;
      closestHeightRow = r;
    }

  });

  if (!closestHeightRow) return 'N/A';

  const sizes = closestHeightRow.sizes;

  // =====================================================
  // FEMALE → Match UK / US size
  // =====================================================

  if (user.gender === "F") {

    const sizeKey = user.size_system === "UK" ? "uk_size" : "us_size";

    // Extract available sizes
    const availableSizes = sizes.map(s => Number(s[sizeKey]));

    const minSize = Math.min(...availableSizes);
    const maxSize = Math.max(...availableSizes);

    // RANGE CHECK
    if (user.numeric_size < minSize || user.numeric_size > maxSize) {
      return 'N/A';
    }

    // Closest match
    let closest = null;
    let minDiff = Infinity;

    sizes.forEach(s => {

      const size = Number(s[sizeKey]);
      const diff = Math.abs(size - user.numeric_size);

      if (diff < minDiff) {
        minDiff = diff;
        closest = s;
      }

    });

    let rSize = closest ? closest.recommended_size : 'N/A';
    if (rSize === null) rSize = 'N/A';

    return rSize;
  }

  // =====================================================
  // MALE → Match chest
  // =====================================================

  if (user.gender === "M") {

    const availableChest = sizes.map(s => Number(s.chest));

    const minChest = Math.min(...availableChest);
    const maxChest = Math.max(...availableChest);

    // RANGE CHECK
    if (user.chest < minChest || user.chest > maxChest) {
      return 'N/A';
    }

    let closest = null;
    let minDiff = Infinity;

    sizes.forEach(s => {

      const chest = Number(s.chest);
      const diff = Math.abs(chest - user.chest);

      if (diff < minDiff) {
        minDiff = diff;
        closest = s;
      }

    });

    let rSize = closest ? closest.recommended_size : 'N/A';
    if (rSize === null) rSize = 'N/A';

    return rSize;
  }

  return 'N/A';
}
